import * as React from "react";

const GraduationCapSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="#FFF"
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="M480-120 200-272v-200L40-560l440-240 440 240v320h-80v-276l-80 44v200L480-120Zm0-89 200-108v-112L480-320 280-429v112l200 108Zm0-199 273-152-273-148-273 148 273 152Zm0 0Z" />
  </svg>
);

export default GraduationCapSVG;